// Shared display formatter for reduction results. Consumed by the Inspector
// (the only result surface — the Reductions pane no longer shows results
// inline). Splits a cached result into a bold headline (value or range, no
// labels) and a muted auxiliary line (count, dimensionality).

import type { ReductionResult } from './types';

export function fmtNum(v: number): string {
    if (!Number.isFinite(v)) return String(v);
    if (Math.abs(v) >= 1e4 || (v !== 0 && Math.abs(v) < 1e-3)) return v.toExponential(3);
    return (Math.round(v * 1e6) / 1e6).toString();
}

export function formatReductionResult(r: ReductionResult | undefined): { main: string; aux: string } {
    if (!r) return { main: '…', aux: 'computing' };
    switch (r.kind) {
        case 'scalar': return { main: fmtNum(r.value), aux: `n = ${r.count}` };
        case 'profile': {
            let mn = Infinity, mx = -Infinity;
            for (let i = 0; i < r.values.length; i++) {
                const v = r.values[i]!;
                if (!Number.isFinite(v)) continue;
                if (v < mn) mn = v;
                if (v > mx) mx = v;
            }
            return { main: `[${fmtNum(mn)}, ${fmtNum(mx)}]`, aux: `(1-D along ${r.axis}) · n = ${r.values.length}` };
        }
        case 'empty': return { main: '—', aux: 'no cells in domain' };
        case 'unsupported': return { main: '—', aux: `unsupported: ${r.reason}` };
    }
}
